import type { InteractionState } from '../types.js';

export function reduceToolbarVisible<T extends InteractionState>(
  visible: boolean,
) {
  return (prev: T): T => ({
    ...prev,
    toolbar: {
      ...prev.toolbar,
      visible,
    },
  });
}
